import { Box, Text } from '@factorialco/deprecated-design-system'

export const AccountNumber = ({ accountNumber }: { accountNumber: string }) => {
  return (
    <Box alignItems="center" flexDirection="row" gap="s8">
      <Text.Normal size="200">*{accountNumber.slice(-4)}</Text.Normal>
    </Box>
  )
}
